import { ApiError } from '@multiplatform-apps/service-trips';
import { FC, PropsWithChildren } from 'react';

interface RequireRoutePermissionProps {
  hasPermission: boolean;
}

export const RequireRoutePermission: FC<
  PropsWithChildren<RequireRoutePermissionProps>
> = ({ hasPermission, children }) => {
  if (!hasPermission) {
    throw new ApiError(403, 'Forbidden');
  }
  return children;
};
